import { useSelector } from 'react-redux';

import { makeGetCurrentUserId, makeGetCurrentUser, makeGetUsers } from 'selectors/users';

const getCurrentUserId = makeGetCurrentUserId();

export const useCurrentUserId = () => {
    const currentUserId = useSelector(({ users }) => getCurrentUserId(users));

    return currentUserId;
};

const getCurrentUser = makeGetCurrentUser();

export const useCurrentUser = () => {
    const currentUser = useSelector(({ users }) => getCurrentUser(users));

    return currentUser;
};

export const useCurrentUserRole = () => {
    const currentUser = useCurrentUser();

    return currentUser?.role;
};

const getUsers = makeGetUsers();

export const useResolvedUsers = userIds => {
    const users = useSelector(({ users }) => getUsers(users.items, userIds));

    return users;
}
